import { EARN as earn } from './earn';
import { REDEEM as redeem } from './redeem';

export const REWARDS = {
  earn,
  redeem
};
